import Doars from './Doars.js'
import { execute } from './utilities/Execute.js'

Doars.executeExpression = execute

export default Doars
